import { render, staticRenderFns } from "./add-new-member.html?vue&type=template&id=2d9404d2&"
import script from "./add-new-member.js?vue&type=script&lang=js&"
export * from "./add-new-member.js?vue&type=script&lang=js&"
import style0 from "./add-new-member.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports